var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    className: "homeIcon",
    height: 21,
    viewBox: "0 0 22 21",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6838 0.0636277L0.158014 8.28556C-0.26625 8.62429 0.243038 9.38748 0.752316 8.96385L1.34662 8.54023V20.4915C1.34662 20.7462 1.6017 21 1.8559 21H8.47742V12.863H13.486V21H20.1076C20.3626 21 20.6168 20.7453 20.6168 20.4915V8.54023L21.2111 8.96385C21.7204 9.38748 22.3147 8.62512 21.8054 8.28556L18.3246 5.57331V2.26746H15.5232V3.45426L11.2788 0.0636715C11.1087 -0.0212238 10.8545 -0.0212238 10.6845 0.0636715L10.6838 0.0636277Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default __webpack_public_path__ + "static/media/home_white.5a13833a366233ca09f15aa5ab8b4d27.svg";
export { ForwardRef as ReactComponent };